import { render } from "./ui-date-picker.vue?vue&type=template&id=de5ec078&ts=true"
import script from "./ui-date-picker.vue?vue&type=script&lang=ts"
export * from "./ui-date-picker.vue?vue&type=script&lang=ts"

import "./ui-date-picker.vue?vue&type=style&index=0&id=de5ec078&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__